import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { FaSun, FaMoon, FaUser } from "react-icons/fa";

interface ThemeToggleProps {
  onHeader?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ onHeader }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div
      className={`${onHeader ? "" : "mb-6"} z-30 lg:block md:block sm:hidden`}
    >
      <div className="glass rounded-3xl p-4 shadow-2xl">
        <button
          onClick={toggleTheme}
          className="group relative w-12 h-12 bg-black/30 backdrop-blur-sm border border-white/30 rounded-2xl flex items-center justify-center text-white/90 hover:text-white transition-all duration-300 hover:scale-110 hover:bg-white/25 group-hover:shadow-lg group-hover:shadow-purple-500/25"
          aria-label={`Switch to ${
            theme === "profile"
              ? "night"
              : theme === "night"
              ? "day"
              : "profile"
          } theme`}
        >
          <div className="relative w-6 h-6 flex items-center justify-center">
            {/* Profile Icon */}
            <FaUser
              className={`absolute transition-all duration-500 ${
                theme === "profile"
                  ? "opacity-100 rotate-0 scale-100 text-profile-suit-blue-500"
                  : "opacity-0 rotate-90 scale-0"
              }`}
            />

            {/* Moon Icon */}
            <FaMoon
              className={`absolute transition-all duration-500 ${
                theme === "night"
                  ? "opacity-100 rotate-0 scale-100 text-blue-300"
                  : "opacity-0 -rotate-90 scale-0"
              }`}
            />

            {/* Sun Icon */}
            <FaSun
              className={`absolute transition-all duration-500 ${
                theme === "day"
                  ? "opacity-100 rotate-0 scale-100 text-yellow-400"
                  : "opacity-0 rotate-90 scale-0"
              }`}
            />
          </div>

          {/* Glow Effect */}
          <div
            className={`absolute inset-0 rounded-2xl transition-all duration-500 ${
              theme === "profile"
                ? "bg-gradient-to-r from-profile-suit-blue-400/20 to-profile-suit-blue-600/20"
                : theme === "day"
                ? "bg-gradient-to-r from-yellow-400/20 to-orange-400/20"
                : "bg-gradient-to-r from-blue-400/20 to-purple-400/20"
            } opacity-0 group-hover:opacity-100`}
          ></div>
        </button>

        {/* Tooltip */}
        <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-black/30 backdrop-blur-xl border border-white/30 rounded-xl px-3 py-2 text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none whitespace-nowrap">
          {theme === "profile"
            ? "Switch to Night"
            : theme === "night"
            ? "Switch to Day"
            : "Switch to Profile"}
          <div className="absolute left-full top-1/2 -translate-y-1/2 w-0 h-0 border-l-4 border-l-white/30 border-t-4 border-t-transparent border-b-4 border-b-transparent"></div>
        </div>
      </div>
    </div>
  );
};

export default ThemeToggle;
